import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWriting: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWriting"><Path d="M18.25 1.68945L11 8.93945V13.0001H15.0607L22.3107 5.75011L18.25 1.68945Z" fill="currentColor"/><Path d="M5.75 11.5C4.23122 11.5 3 12.7312 3 14.25C3 15.7688 4.23122 17 5.75 17H16.25C16.9404 17 17.5 17.5596 17.5 18.25C17.5 18.9404 16.9404 19.5 16.25 19.5H11V21H16.25C17.7688 21 19 19.7688 19 18.25C19 16.7312 17.7688 15.5 16.25 15.5H5.75C5.05964 15.5 4.5 14.9404 4.5 14.25C4.5 13.5596 5.05964 13 5.75 13H9V11.5H5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWriting;
